import { FeatureNodeType } from '../../../data/features';
import {
  FEATURE_GOALS,
  FEATURE_LANGUAGES,
  FEATURE_TEAM_OPTIONS,
  FEATURE_GOVERNANCE_OPTIONS,
  FeatureGovernanceId,
  FeatureTeamId,
  FeatureLanguageId,
  FeatureGoalId,
  FeatureTraitId,
  FeatureBuildMethodId,
  getAvailableTraits,
  getAvailableBuildMethods
} from '../../../data/featureWizard';

export interface FeatureSelection {
  goals: FeatureGoalId[];
  traits: FeatureTraitId[];
  methods: FeatureBuildMethodId[];
  language?: FeatureLanguageId;
  team?: FeatureTeamId;
  governance: FeatureGovernanceId[];
  query: string;
  types: FeatureNodeType[];
}

export const readFeatureSelection = (params: URLSearchParams): FeatureSelection => {
  const goals = FEATURE_GOALS.filter((goal) => params.getAll('goal').includes(goal.id)).map((goal) => goal.id);
  const traits = getAvailableTraits(goals)
    .filter((option) => params.getAll('trait').includes(option.id))
    .map((option) => option.id);
  const methods = getAvailableBuildMethods(goals)
    .filter((option) => params.getAll('method').includes(option.id))
    .map((option) => option.id);
  const requestedTypes = params
    .getAll('type')
    .flatMap((type) => (type === 'subsystem' ? [FeatureNodeType.CLOUD_SERVICE, FeatureNodeType.RUNTIME] : [type]));
  const types = params.has('type')
    ? Object.values(FeatureNodeType).filter((type) => requestedTypes.includes(type))
    : Object.values(FeatureNodeType);
  return {
    goals,
    governance: FEATURE_GOVERNANCE_OPTIONS.filter((option) => params.getAll('governance').includes(option.id)).map(
      (option) => option.id
    ),
    traits,
    methods,
    team: FEATURE_TEAM_OPTIONS.find((option) => option.id === params.get('team'))?.id,
    language: FEATURE_LANGUAGES.find((option) => option.id === params.get('language'))?.id,
    query: params.get('q') || '',
    types
  };
};

export const featureSelectionParams = (selection: FeatureSelection): URLSearchParams => {
  const params = new URLSearchParams();
  selection.goals.forEach((goal) => params.append('goal', goal));
  selection.traits.forEach((trait) => params.append('trait', trait));
  selection.methods.forEach((method) => params.append('method', method));
  selection.governance.forEach((id) => params.append('governance', id));
  if (selection.team) params.set('team', selection.team);
  if (selection.language) params.set('language', selection.language);
  if (selection.query) params.set('q', selection.query);
  if (selection.types.length === 0) params.set('type', 'none');
  else if (selection.types.length < Object.values(FeatureNodeType).length)
    selection.types.forEach((type) => params.append('type', type));
  return params;
};
